import { render, staticRenderFns } from "./search_tax_form.vue?vue&type=template&id=6a489a10&scoped=true&"
import script from "./search_tax_form.vue?vue&type=script&lang=js&"
export * from "./search_tax_form.vue?vue&type=script&lang=js&"
import style0 from "./search_tax_form.vue?vue&type=style&index=0&id=6a489a10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a489a10",
  null
  
)

export default component.exports